import { render, staticRenderFns } from "./Template2.vue?vue&type=template&id=fe7f2c12&scoped=true&"
import script from "./Template2.vue?vue&type=script&lang=js&"
export * from "./Template2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7f2c12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe7f2c12')) {
      api.createRecord('fe7f2c12', component.options)
    } else {
      api.reload('fe7f2c12', component.options)
    }
    module.hot.accept("./Template2.vue?vue&type=template&id=fe7f2c12&scoped=true&", function () {
      api.rerender('fe7f2c12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/JVxeDemo/layout-demo/Template2.vue"
export default component.exports